import styled from 'styled-components';

const CookiePolicyLink = styled.a`
  text-decoration: underline;
  color: #000000 !important;
`;

export default CookiePolicyLink;
